// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app{width:100%;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#2c3e50;font-size:0}body{margin:0 auto;background:#f7f7f7}.title-bold{font-size:24px!important;font-weight:700!important;color:#3764d7!important}.title-default{font-size:14px!important;font-weight:400!important;color:#3764d7!important}@media screen and (max-width:575px){body,html{width:100%;height:100%;position:relative}}", ""]);
// Exports
module.exports = exports;
